import Home from './home';
import Recommend from './recommend';

import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

function AnimatedRoutes() {
    const location = useLocation();

    return (
        <AnimatePresence mode='wait'>
            <Routes key={location.pathname} location={location}>
            <Route path='/' element={<Home />} />
            {/* <Route path='/recommend' element={<Recommend />} /> */}
            <Route
                path="*"
                element={<Navigate to="/" replace />}
            />
            </Routes>
        </AnimatePresence>
    )
}

export default AnimatedRoutes;